export interface ArchiveRequestGallery {
  gallery: string;
  zip_dir: string;
  items: string[] | undefined;
  datas: { uuid: string; extension: string }[];
}

export type ArchiveSize = 'small' | 'medium' | 'large' | 'original';

export const GALLERY_DOWNLOAD_SIZE = {
  original: 0,
  large: 2400,
  medium: 1920,
  small: 720,
};

export interface ArchiveRequest {
  size: ArchiveSize;
  zip_name: string;
  zip_parameters: ArchiveRequestGallery[];
}

export interface Archive {
  id: string;
  size: ArchiveSize;
  status: 'resizing' | 'pending' | 'completed' | 'failed';
  zip_name: string;
  zip_parameters: [];
  sha1_base64: string;
  download_url: string;
  total_size: string;
  number_items: number;
}
